import React, { useEffect, useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import addIcon from "../../../../../assets/disabilityIcons/Frame 427319007.svg";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import { MODULE_API } from "../../../../../apis";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import { Table } from "antd";
import "./styles/primarycaregivers.css";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export default function PrimaryCaregivers(props) {
  const [fields, setFields] = useState({});
  const [subModulefields, setSubModuleFields] = useState(null);
  const [tabs, setTabs] = useState([]);
  const [moduleName, setModuleName] = useState(null);
  const [fieldsData, setFieldsData] = useState({});
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formData, setFormData] = useState({});
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [modalTitle, setModalTitle] = useState("");

  const [toUpdate, setToUpdate] = useState(false);
  const [tableData, setTableData] = useState({});

  const showModal = async (name) => {
    setModalTitle(name);
    setIsModalVisible(true);
    setModuleName(name);
    setSubModuleFields(null);
    await getSubModuleAttribute(name);
  };
  const viewModal = async (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModuleName(record.module);
    setModalTitle("View Item");
    setSubModuleFields(null);
    await getSubModuleAttribute(record.module);
  };
  const updateModal = async (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModuleName(record.module);
    setModalTitle("Update");
    setSubModuleFields(null);
    await getSubModuleAttribute(record.module);
  };
  const createAttributes = async () => {
    try {
      setLoading(true);
      await MODULE_API.addAsset("Primary Caregivers", {
        clientModules: [formData],
      });
      setToUpdate(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setFormData(null);
    }
  };
  const deleteRecord = async (record) => {
    try {
      setLoading(true);
      await MODULE_API.deleteItem({
        clientModules: [record.id],
      });
      const res = await fetchData(record.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(record.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const getAttribute = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchAttributes(moduleName);
      if (res) {
        res.attributes &&
          res.attributes.map((attribute) => {
            setLoading(false);
            setFields((prevValue) => {
              return {
                ...prevValue,
                [attribute["groupName"]]: {
                  ...(prevValue[attribute["groupName"]] || {}),
                  [attribute["id"]]: attribute,
                },
              };
            });
          });
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    }
  };
  const getSubModuleAttribute = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchAttributes(moduleName);
      if (res) {
        setSubModuleFields(res);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching attributes", error);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleItemsInfoSelect = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handelCloseModal = () => {
    setIsModalVisible(false);
    setFormData(null);
  };
  const handleCreate = async () => {
    try {
      setLoading(true);
      const result = await MODULE_API.addAsset(moduleName, {
        clientModules: [formData],
      });
      console.log("resultob", result);
      const res = await fetchData(moduleName);
      console.log("resultob", res.records, moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
    } finally {
      setFormData(null);
      setLoading(false);
    }
  };
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      const res = await fetchData(formData.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(formData.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
      setFormData(null);
    } catch (error) {
    } finally {
      setFormData(null);
      setLoading(false);
    }
  };
  const formatModuleKey = (moduleName) => {
    return (
      moduleName &&
      moduleName
        .replace(/[^a-zA-Z ]/g, "") // Remove special chars
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "") + "Data"
    );
  };
  const fetchData = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      const records = res.records || [];
      setLoading(false);
      return { moduleName, records }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    } finally {
      setLoading(false);
    }
  };
  const moduleNames = ["Primary Caregivers", "Primary Caregiver"];
  const fetchAllModulesData = async () => {
    try {
      setLoading(true);
      const results = await Promise.all(moduleNames.map((name) => fetchData(name)));
      console.log("All module results:", results);
      const primaryCaresGiverMod = results.find((item) => item.moduleName === "Primary Caregivers");
      if (primaryCaresGiverMod) {
        const targetRecord = primaryCaresGiverMod.records.find(
          (record) => record.subType === "Disability" || "Professional Care Provider" in record
        );
        setFieldsData(targetRecord);
      } else {
        console.log("Medical History module not found");
      }

      const tableDataObj = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});

      setTableData(tableDataObj);
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  console.log("tableData", tableData);
  useEffect(() => {
    getAttribute(props.activeStep.name);
    fetchAllModulesData();
  }, []);

  useEffect(() => {
    setTabs(Object.keys(fields));
  }, [fields]);
  useEffect(() => {
    if (fieldsData && fieldsData.id) {
      setToUpdate(true);
    }
  }, [fieldsData]);
  console.log(fields);
  const careGiversColsdata = [
    {
      title: "Name",
      dataIndex: "Name",
      key: "name",
      render: (text) => text || "N/A",
    },
    {
      title: "Relationship",
      dataIndex: "Relationship",
      key: "relationship",
      render: (text) => text || "N/A",
    },
    {
      title: "Availability",
      dataIndex: "Availability",
      key: "availability",
      render: (text) => text || "N/A",
    },
    {
      title: "Responsibilities",
      dataIndex: "Responsibilities",
      key: "responsibilities",
      render: (text) => text || "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];

  console.log("formData", formData);

  return (
    <>
      <div className="primary-caregiver-container">
        <div className="legal-document-title-container">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <h2 className="primary-caregiver-title">Primary Caregivers</h2>
          <ToolTipCreator name={"Disability_Primary_Caregivers"}/>
        </div>
        </div>
        {/* <div className="primary-caregiver-icon-container">
          <img src={helpIcon} alt="help" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      <div className="primary-caregiver-box-container">
        <div className="primary-caregiver-header-container">
          <h3 className="primary-caregiver-box-title">Primary Caregivers</h3>
          <div
            className="primary-caregiver-add-button-container"
            onClick={() => showModal("Primary Caregiver")}
            style={{ cursor: "pointer" }}
          >
            <img src={addIcon} alt="" width={"24px"} height={"24px"} />
          </div>
        </div>
        <div className="primary-caregiver-table-container">
          <Table columns={careGiversColsdata} dataSource={tableData.primaryCaregiverData} />
          <NewLoader isLoading={loading} />
        </div>
      </div>
      <div>
        <CustomModal
          show={isModalVisible}
          fields={subModulefields && subModulefields}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? handleCreate : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={formData}
          loading={loading}
        />
      </div>
      <div className="input-field-container">
        {tabs.length > 0 && (
          <>
            <DisabilityFormCreator
              data={fields["Primary Caregivers"]}
              values={fieldsData}
              setSubmitBody={setFormData}
            />
          </>
        )}
      </div>
      {!loading && fields && (
        <div className="handle-submit-button-container">
          <button
            className="submit-button"
            onClick={() => {
              if (toUpdate) {
                updateRecord();
              } else {
                createAttributes();
              }
            }}
          >
            {toUpdate ? "Update" : "Submit"}
          </button>
        </div>
      )}
    </>
  );
}
